/* LUCRÜ™ — © 2026 LUCRÜ. All rights reserved. */
import { useState } from "react";
import { toast } from "sonner";
import { QrCodeIcon, CopyIcon, DeviceMobileIcon, XIcon } from "@phosphor-icons/react";
import { motion, AnimatePresence } from "framer-motion";

const RelayShare = ({ sessionId }) => {
  const [open, setOpen] = useState(false);
  const url = `${window.location.origin}/relay/${sessionId}`;

  const copy = () => {
    navigator.clipboard.writeText(url);
    toast.success("Relay link copied");
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="btn-pill btn-ghost w-full justify-center"
        data-testid="open-relay-share"
      >
        <DeviceMobileIcon size={16} /> Mobile relay link
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
          >
            <motion.div
              className="bg-[#0F0F16] border border-[#222233] rounded-2xl p-6 max-w-sm w-full"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="font-display font-black text-lg">Mobile relay</div>
                <button onClick={() => setOpen(false)}><XIcon size={18} /></button>
              </div>
              <p className="text-xs text-white/60 mb-4 leading-relaxed">
                Open this link on your streaming phone or share it with a trusted mod. They type the chat messages, you hear them read aloud.
              </p>

              <div className="bg-[#05050A] border border-[#222233] rounded-xl p-3 flex items-center justify-center mb-4">
                <img
                  alt="QR code"
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&bgcolor=05050A&color=00E5FF&data=${encodeURIComponent(url)}`}
                  className="rounded-md"
                />
              </div>

              <div className="bg-[#05050A] border border-[#222233] rounded-lg px-3 py-2 text-xs font-mono text-white/70 break-all mb-3">
                {url}
              </div>
              <button onClick={copy} className="btn-pill btn-primary w-full justify-center" data-testid="copy-relay-link">
                <CopyIcon size={16} weight="fill" /> Copy link
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default RelayShare;
